import { useSelector } from 'react-redux';
import {
  selectMenus,
  selectStatus,
  AUTH_STATUS,
} from '../features/auth/authSlice';
import { Redirect } from 'react-router-dom';
import HttpError from './HttpError';
import LayoutDefault from './LayoutDefault';

/*
如果未登录，跳转至登录页面
如果已登录，跳转至第一个菜单
如果已登录，无菜单，显示403错误
*/
const RedirectDefault = () => {
  const status = useSelector(selectStatus);
  const menus = useSelector(selectMenus);
  let url;
  if (status === AUTH_STATUS.SUCCEEDED) {
    if (menus.length > 0) {
      url = getDefaultFromMenus(menus);
    } else {
      return <HttpError code={403} home={false} layout={LayoutDefault} />;
    }
  } else {
    url = '/signin';
  }
  return <Redirect to={url} />;
};
export default RedirectDefault;

function getDefaultFromMenus(menus) {
  let url;
  for (let menu of menus) {
    if (menu.url) {
      url = menu.url;
      break;
    } else if (menu.children && menu.children.length > 0) {
      url = getDefaultFromMenus(menu.children);
      if (url) {
        break;
      }
    }
  }
  return url;
}
